import { render, staticRenderFns } from "./r-item-state-dropdown.vue?vue&type=template&id=489443cb&scoped=true"
import script from "./r-item-state-dropdown.vue?vue&type=script&lang=js"
export * from "./r-item-state-dropdown.vue?vue&type=script&lang=js"
import style0 from "./r-item-state-dropdown.vue?vue&type=style&index=0&id=489443cb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489443cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489443cb')) {
      api.createRecord('489443cb', component.options)
    } else {
      api.reload('489443cb', component.options)
    }
    module.hot.accept("./r-item-state-dropdown.vue?vue&type=template&id=489443cb&scoped=true", function () {
      api.rerender('489443cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-state-dropdown.vue"
export default component.exports